var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-comments-container" },
    [
      _c("div", { staticClass: "wl-title" }, [
        _vm._v(_vm._s(_vm.$t("PAGE_MATTERLOG_COMMENTS"))),
      ]),
      _c("m-tree", {
        ref: "tree",
        attrs: { data: this.data.commentList, onAdd: _vm.onAddComment },
      }),
      _c("div", { staticClass: "wl-title" }, [
        _vm._v(_vm._s(_vm.$t("PAGE_MATTERLOG_REPLY"))),
      ]),
      _c("add-comment", {
        attrs: {
          loading: _vm.loading,
          pid: _vm.data.id,
          onAdd: _vm.onAddComment,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }